import axios from "axios";
import { REACT_PUBLIC_CONSENT_CLIENT_ID } from "../constants/static";
import { accessTokenUrl, returnUrl } from "../constants/urls";

export const getAccessToken = async (cidmUrl: string, code?: string) => {
  const accessTokenURL = cidmUrl + accessTokenUrl;
  const redirect_uri = window.location.origin + returnUrl;
  const codeVerifier = sessionStorage.getItem("codeVerifier");
  // const environmentVars = useConfig();
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    withCredentials: true,
  };

  const requestParams = new URLSearchParams();
  requestParams.append("client_id", REACT_PUBLIC_CONSENT_CLIENT_ID || "");
  requestParams.append("grant_type", "authorization_code");
  requestParams.append("redirect_uri", redirect_uri || "");
  requestParams.append("code", code || "");
  requestParams.append("code_verifier", codeVerifier || "");

  return await axios.post(accessTokenURL, requestParams, config);
};
